import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const additionalBranchDetails = () => ({
    "collection-agency" : {
        header : "Add additional branches",
        text : [
            "Provide the following information for each additional branch that collects from Nova Scotians."
        ],
        headerRenewal : "Add additional branches",
        textRenewal : [
            "Review the following information for each additional branch that collects from Nova Scotians."
        ],
        navigation : {
            next : ROUTE_PATH.SUPPORTING_DOCUMENTS,
            nextRenewal : ROUTE_PATH.SUPPORTING_DOCUMENTS
        }
    },
    "debt-management-agency" : {
        header : "Add additional branches",
        text : [
            "Provide the following information for each additional branch that manages debt for Nova Scotians."
        ],
        headerRenewal : "Add additional branches",
        textRenewal : [
            "Review the following information for each additional branch that manages debt for Nova Scotians."
        ],
        navigation : {
            next : ROUTE_PATH.SUPPORTING_DOCUMENTS,
            nextRenewal : ROUTE_PATH.SUPPORTING_DOCUMENTS
        }
    }
})

const newBranchApplicationDetails = () => ({
    "collection-agency" : {
        header : "Add additional branches",
        text : [
            "Provide the following information for each additional branch that collects from Nova Scotians."
        ],
        managerHelperText : [
            "The Responsible Agent must have a valid Collector Licence."
        ],
        navigation : {
            next : ROUTE_PATH.BRANCH_APPLICATION_REVIEW,
        }
    },
    "debt-management-agency" : {
        header : "Add additional branches",
        text : [
            "Provide the following information for each additional branch that  manages debt from Nova Scotians."
        ],
        managerHelperText : [
            "The Responsible Agent must have a valid Debt Management Agent Licence."
        ],
        navigation : {
            next : ROUTE_PATH.BRANCH_APPLICATION_REVIEW,
        }
    }  
})

const additionalBranchQuestion = () => ({
    "collection-agency" : {
        header : "Additional branches",
        text : [
            "Do you have additional branches (not including your head office) that collect debt from Nova Scotians?"
        ],
        navigation : {
            yes : ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS,
            no : ROUTE_PATH.SUPPORTING_DOCUMENTS
        }
    },
    "debt-management-agency" : {
        header : "Additional branches",
    text : [
        "Do you have additional branches (not including your head office) that manages debt for Nova Scotians?"
    ],
    navigation : {
        yes : ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS,
        no : ROUTE_PATH.SUPPORTING_DOCUMENTS
    }
    }
    
})

const additionalBranchQuestionSlice = createSlice({
    name : 'additionalBranchQuestion',
    initialState: additionalBranchQuestion(),
    reducers: {
        setAdditionalBranchQuestionAnswer(state, action) {
            state.additionalBranchQuestionAnswer = action.payload
        }
    }
})

export const {setAdditionalBranchQuestionAnswer} = additionalBranchQuestionSlice.actions

export const additionalBranchQuestionReducer = additionalBranchQuestionSlice.reducer

const additionalBranchDetailsSlice = createSlice({
    name : 'additionalBranchDetails',
    initialState: additionalBranchDetails(),
    reducers: {}      
})

export const additionalBranchDetailsReducer = additionalBranchDetailsSlice.reducer

const newBranchApplicationDetailsSlice = createSlice({
    name: 'newBranchApplicationDetails',
    initialState: newBranchApplicationDetails(),
    reducers: {}
})

export const newBranchApplicationDetailsReducer = newBranchApplicationDetailsSlice.reducer
